import React from 'react';
import { PlusIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PriceBlock } from './PriceBlock';
import { TrustStrip } from './TrustStrip';
import { MAIN_MOCKUP, MOCKUP_ALT, offerItems } from '../data/poolContent';
export function OfferSection() {
  return <section id="offer" className="w-full border-y border-aqua/20 bg-black py-14 sm:py-20" aria-labelledby="offer-title" data-id="element-246" data-mp="ddvfle6ywde1">
      <div className="mx-auto max-w-5xl px-5" data-id="element-247" data-mp="icoth7q626eq">
        <h2 id="offer-title" className="text-center font-display text-[2.2rem] font-bold uppercase leading-none text-frost-50 sm:text-[3.2rem]" data-id="element-248" data-mp="metni7kj151w">
          One purchase.
          <span className="block text-aqua" data-id="element-249" data-mp="wczo8lulk556">A much more independent pool owner.</span>
        </h2>

        <div className="mt-10 grid items-center gap-10 md:grid-cols-2" data-id="element-250" data-mp="2t59lrjt43uq3">
          <img src={MAIN_MOCKUP} alt={MOCKUP_ALT} className="mx-auto w-full max-w-sm md:max-w-none" width={1199} height={1312} loading="lazy" data-id="element-251" data-mp="2t7dxgnx95y0x" />

          <div className="rounded-2xl border border-pool/30 bg-abyss-900 p-6 sm:p-8" data-id="element-252" data-mp="xx1y7ws1oi50">
            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-aqua" data-id="element-253" data-mp="xuz16ssh5oqs">You get</p>
            <ul className="mt-4" data-id="element-254" data-mp="ow3sna1yk2kb">
              {offerItems.map((item, i) => <li key={item.title} data-id="element-255" data-mp="ou0to0ituz3g" data-mpi={i}>
                  {i > 0 && <PlusIcon className="my-1 h-3.5 w-3.5 text-pool" strokeWidth={2.5} aria-hidden="true" data-id="element-256" data-mp="1ll340xxu9kgq" />}
                  <p className="font-display text-[1.25rem] font-bold uppercase leading-tight text-frost-50" data-id="element-257" data-mp="1gl6vcle754uu">
                    {item.title}
                  </p>
                  {item.note && <p className="text-[11px] font-medium uppercase tracking-[0.14em] text-muted" data-id="element-258" data-mp="17opj1eu3j0xi">
                      {item.note}
                    </p>}
                </li>)}
            </ul>

            <PriceBlock align="start" className="mt-7 border-t border-abyss-600 pt-6" data-id="element-259" data-mp="3tu99x98xnfit" />

            <div className="mt-6" data-id="element-260" data-mp="2noj9qmsi9mb">
              <CtaButton size="md" label="Get the Complete System Now →" data-id="element-261" data-mp="2mn8ln9orp54" />
            </div>
            <TrustStrip className="mt-4 sm:justify-start" data-id="element-262" data-mp="3ku2x7pl26jkp" />
          </div>
        </div>
      </div>
    </section>;
}